export enum LayoutShowDateFormat {
  NUMERIC = "NUMERIC",
  SHORT_MONTH = "SHORT_MONTH",
  FULL_MONTH = "FULL_MONTH",
}
